import { getField, updateField } from "vuex-map-fields";
import myAccounts from "./myAccounts";
import cacInq from "./cacInq";
import bnkChekInq from "./bnkChekInq";
import calendarInq from "./calendarInq";
import statementInq from "./statementInq";

const getDefaultState = () => {
  return {
    //전계좌조회 - 필터 전
    RBF0404F40: {},
    //계좌리스트 - 필터 후
    customAccountList: [],
    //init계좌정보
    initAcno: {},
  };
};

const accounts = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setWholAcn_init: state => {
      state.RBF0404F40 = getDefaultState().RBF0404F40;
      state.customAccountList = getDefaultState().customAccountList;
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("myAccounts/resetState");
      commit("cacInq/resetState");
      commit("bnkChekInq/resetState");
      commit("calendarInq/resetState");
      commit("statementInq/resetState");
    },
    act_setWholAcn_init: context => {
      context.commit("setWholAcn_init");
    },
  },
  modules: {
    myAccounts,
    cacInq,
    bnkChekInq,
    calendarInq,
    statementInq,
  },
};

export default accounts;
